import { App } from 'antd';
import { create } from 'zustand';

interface NotificationState {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

/** Không lưu lại giữa các lần mở — như bản cũ: thông báo chỉ sống khi tab này còn mở. */
const useNotificationStore = create<NotificationState>((set) => ({
  enabled: false,
  setEnabled: (enabled) => set({ enabled }),
}));

export const isBrowserNotificationEnabled = () => useNotificationStore.getState().enabled;

export function useNotificationPreference() {
  const { enabled, setEnabled } = useNotificationStore();
  const { message } = App.useApp();

  const toggle = async () => {
    if (enabled) {
      setEnabled(false);
      return void message.info('Đã tắt thông báo');
    }
    if (!('Notification' in window)) {
      return void message.warning('Trình duyệt này không hỗ trợ thông báo');
    }
    if (Notification.permission === 'denied') {
      return void message.warning('Trình duyệt đã chặn — bật lại trong cài đặt trình duyệt');
    }
    try {
      const permission =
        Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
      if (permission !== 'granted') return void message.warning('Chưa cấp quyền thông báo');
      setEnabled(true);
      void message.success('Đã bật — chỉ hiện khi tab này còn mở');
    } catch {
      void message.warning('Không xin được quyền thông báo');
    }
  };

  return { enabled, toggle };
}
